module.exports = ":host /deep/ clr-tabs ul {\n  margin-top: -0.4rem; }\n\n:host /deep/ h5 {\n  margin-bottom: 15px;\n  margin-top: 8px; }\n"